export default {
  taskList: [],
  total: 0,
};
